import styled from 'styled-components';
import { StyledTabsProps } from './Tabs.types';

export const StyledTabs = styled.div<StyledTabsProps>`
  display: flex;
  flex-direction: column;

  .tabs__tab-label {
    background-color: transparent;
    border: none;
    cursor: pointer;
  }

  ${(props) => props.customStyle}
`;
